module.exports = __webpack_public_path__ + "static/media/Sprint_StreamingEntertainment.d4a4c702.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/ExperienceCards/SHS-SPRINT/Sprint_StreamingEntertainment.jpg
// module id = 3763
// module chunks = 0